namespace appn.views.tasks.presets {

    export function init(): void {
        addEvents();
    }

    function addEvents() {
        // Refresh the page if changes were made in modal
        $(document).on('hidden.bs.modal', function() {
            if (iframe.getHost().reloadFlag)
                appn.location.reloadCurrentPage();
        });
    }
}
